export default __webpack_public_path__ + "static/media/banner3.4d02a890.png";